module.exports = __webpack_public_path__ + "static/media/savi.87d1087c.png";